import { render, staticRenderFns } from "./ScoringTaskList.vue?vue&type=template&id=53d19dd4&scoped=true&"
import script from "./ScoringTaskList.vue?vue&type=script&lang=js&"
export * from "./ScoringTaskList.vue?vue&type=script&lang=js&"
import style0 from "./ScoringTaskList.vue?vue&type=style&index=0&id=53d19dd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d19dd4",
  null
  
)

export default component.exports